export const PAY_OUT_STATUS_DEF_GET = "/PayOutStatusDef/GetAllPayOutStatusDef"